import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import store from '@/store'

Vue.use(VueRouter)

import Layout from '@/layout'

export const constantRoutes = [
  { path: '/login', component: () => import('@/views/login/index.vue'), hidden: true },
  { path: '/', redirect: '/dashboard', hidden: true },
]

export const asyncRoutes = [
  {
    path: '/dashboard',
    component: Layout,
    children: [{ path: '', name: 'Dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { title: '首页概览', icon: 's-home' } }],
  },
  {
    path: '/ai',
    component: Layout,
    redirect: '/ai/decision',
    meta: { title: 'AI辅助', icon: 'cpu' },
    children: [
      { path: 'decision', name: 'AiDecision', component: () => import('@/views/ai/decision.vue'), meta: { title: 'AI辅助决策' } },
      { path: 'analysis', name: 'AiAnalysis', component: () => import('@/views/ai/analysis.vue'), meta: { title: 'AI辅助分析' } },
    ],
  },
  {
    path: '/vendor',
    component: Layout,
    redirect: '/vendor/list',
    meta: { title: '供应商管理', icon: 's-cooperation' },
    children: [
      { path: 'list', name: 'VendorList', component: () => import('@/views/vendor/list.vue'), meta: { title: '供应商列表' } },
      { path: 'detail/:id', name: 'VendorDetail', component: () => import('@/views/vendor/detail.vue'), meta: { title: '供应商详情' }, hidden: true },
      { path: 'change-audit', name: 'VendorChangeAudit', component: () => import('@/views/vendor/changeAudit.vue'), meta: { title: '信息变更审批' } },
      { path: 'qualification-audit', name: 'VendorQualificationAudit', component: () => import('@/views/vendor/qualificationAudit.vue'), meta: { title: '资质审核' } },
      { path: 'contract-manage', name: 'VendorContractManage', component: () => import('@/views/vendor/contractManage.vue'), meta: { title: '合同管理' } },
      { path: 'shutdown-audit', name: 'VendorShutdownAudit', component: () => import('@/views/vendor/shutdownAudit.vue'), meta: { title: '关停审批' } },
    ],
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/center',
    meta: { title: '商品中心', icon: 's-goods' },
    children: [
      { path: 'center', name: 'ProductCenter', component: () => import('@/views/product/center.vue'), meta: { title: '商品中心' } },
      { path: 'audit', name: 'ProductAuditQueue', component: () => import('@/views/product/center.vue'), props: { queueOnly: true }, meta: { title: '商品审核' } },
      { path: 'audit/:id', name: 'ProductAuditDetail', component: () => import('@/views/product/audit.vue'), meta: { title: '商品审核详情' }, hidden: true },
      { path: 'detail/:id', name: 'ProductDetail', component: () => import('@/views/product/audit.vue'), meta: { title: '商品详情' }, hidden: true },
    ],
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/order/monitor',
    meta: { title: '订单中心', icon: 's-order' },
    children: [
      { path: 'monitor', name: 'OrderMonitor', component: () => import('@/views/order/monitor.vue'), meta: { title: '采购订单监控' } },
      { path: 'report', name: 'OrderReportAudit', component: () => import('@/views/order/report.vue'), meta: { title: '报备订单审核' } },
      { path: 'reverse', name: 'OrderReverseAudit', component: () => import('@/views/order/reverse.vue'), meta: { title: '反采申请审核' } },
      { path: 'ship', name: 'OrderShipManage', component: () => import('@/views/order/ship.vue'), meta: { title: '发货单管理' } },
    ],
  },
  {
    path: '/bidding',
    component: Layout,
    redirect: '/bidding/purchase',
    meta: { title: '竞价询价', icon: 'data-line' },
    children: [
      { path: 'purchase', name: 'BiddingPurchase', component: () => import('@/views/bidding/purchase.vue'), meta: { title: '采购竞价管理' } },
      { path: 'inquiry', name: 'BiddingInquiry', component: () => import('@/views/bidding/inquiry.vue'), meta: { title: '询价单管理' } },
    ],
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '/finance/bill',
    meta: { title: '财务结算', icon: 's-finance' },
    children: [
      { path: 'bill', name: 'FinanceBill', component: () => import('@/views/finance/bill.vue'), meta: { title: '对账单管理' } },
      { path: 'invoice', name: 'FinanceInvoice', component: () => import('@/views/finance/invoice.vue'), meta: { title: '发票管理' } },
    ],
  },
  {
    path: '/aftersale',
    component: Layout,
    redirect: '/aftersale/manage',
    meta: { title: '售后服务', icon: 'warning' },
    children: [
      { path: 'manage', name: 'AftersaleManage', component: () => import('@/views/aftersale/manage.vue'), meta: { title: '售后管理' } },
    ],
  },
  {
    path: '/service',
    component: Layout,
    redirect: '/service/agent',
    meta: { title: '客服管理', icon: 'service' },
    children: [
      { path: 'agent', name: 'ServiceAgent', component: () => import('@/views/service/agent.vue'), meta: { title: '客服档案' } },
      { path: 'schedule', name: 'ServiceSchedule', component: () => import('@/views/service/schedule.vue'), meta: { title: '排班管理' } },
      { path: 'stats', name: 'ServiceStats', component: () => import('@/views/service/stats.vue'), meta: { title: '接待统计' } },
      { path: 'log', name: 'ServiceLog', component: () => import('@/views/service/log.vue'), meta: { title: '分配日志' } },
    ],
  },
  {
    path: '/help',
    component: Layout,
    redirect: '/help/article',
    meta: { title: '帮助中心', icon: 'reading' },
    children: [
      { path: 'article', name: 'HelpArticle', component: () => import('@/views/help/article.vue'), meta: { title: '文章管理' } },
      { path: 'category', name: 'HelpCategory', component: () => import('@/views/help/category.vue'), meta: { title: '分类管理' } },
      { path: 'feedback', name: 'HelpFeedback', component: () => import('@/views/help/feedback.vue'), meta: { title: '反馈统计' } },
    ],
  },
  {
    path: '/guide',
    component: Layout,
    redirect: '/guide/config',
    meta: { title: '页面引导', icon: 'promotion' },
    children: [
      { path: 'config', name: 'GuideConfig', component: () => import('@/views/guide/config.vue'), meta: { title: '引导配置' } },
    ],
  },
  {
    path: '/exception',
    component: Layout,
    redirect: '/exception/index',
    meta: { title: '结算异常', icon: 'bell' },
    children: [
      { path: 'index', name: 'ExceptionIndex', component: () => import('@/views/exception/index.vue'), meta: { title: '异常工单' } },
    ],
  },
  {
    path: '/voucher',
    component: Layout,
    redirect: '/voucher/index',
    meta: { title: '凭证审核', icon: 'picture' },
    children: [
      { path: 'index', name: 'VoucherIndex', component: () => import('@/views/voucher/index.vue'), meta: { title: '签收凭证' } },
    ],
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/role',
    meta: { title: '系统管理', icon: 'setting' },
    children: [
      { path: 'role', name: 'SystemRole', component: () => import('@/views/system/role.vue'), meta: { title: '角色权限' } },
      { path: 'account', name: 'SystemAccount', component: () => import('@/views/system/account.vue'), meta: { title: '账号管理' } },
      { path: 'brand', name: 'SystemBrand', component: () => import('@/views/system/brand.vue'), meta: { title: '小亿设置' } },
      { path: 'menu', name: 'SystemMenu', component: () => import('@/views/system/menu.vue'), meta: { title: '菜单管理' } },
      { path: 'message', name: 'SystemMessage', component: () => import('@/views/system/message.vue'), meta: { title: '消息中心' } },
    ],
  },
  {
    path: '/logs',
    component: Layout,
    meta: { title: '日志中心', icon: 'document' },
    children: [
      { path: '', name: 'LogCenter', component: () => import('@/views/logs/index.vue'), meta: { title: '操作日志' } },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes: [...constantRoutes, ...asyncRoutes],
})

const whiteList = ['/login']

router.beforeEach((to, from, next) => {
  const token = getToken()
  const allowed = store.getters.allowedTopPaths || []
  if (to.meta && to.meta.title) document.title = to.meta.title + ' - 供应商平台管理端'
  const user = store.state.userInfo
  if (token) {
    if (to.path === '/login') {
      next({ path: allowed[0] || '/dashboard' })
      return
    }
    // 角色菜单级权限控制：禁止直接访问角色不可见的一级菜单及其子页
    const ok = allowed.some(p => to.path === p || to.path.startsWith(p + '/'))
    if (!ok) {
      // 无权限：重定向到首个可见菜单；若 menuPaths 为空或首个菜单自身亦不可见，则放行当前路由避免死循环
      if (!allowed.length) return next()
      const fb = allowed[0]
      const fbOk = allowed.some(p => fb === p || fb.startsWith(p + '/'))
      if (fbOk) return next(fb)
      if (from.path && from.path !== to.path) return next(from.path)
      return next()
    }
    next()
  } else {
    if (whiteList.includes(to.path)) next()
    else next('/login')
  }
})

export default router
